<ng-container>
    <app-bread-crumbs [lang]="lang" [routes]="nameRouting"></app-bread-crumbs>
    <div
        class="inner-container section-gap pt-0"
        style="padding-bottom: 2rem !important"
    >
        <div class="container">
            <div class="multi-imgs-area d-flex" 
                *ngIf="showOffers &&
                  (environmentVariables?.FLYER_IMAGE_WEB_IN_DEALS_PAGE_1
                || environmentVariables?.FLYER_IMAGE_WEB_IN_DEALS_PAGE_2 
                || environmentVariables?.FLYER_IMAGE_WEB_IN_DEALS_PAGE_3)">
              <ng-container >
                <div class="single-img" >
                  <img  loading="lazy" 
                      [ngClass]="{'hide-image-offer' : !environmentVariables?.FLYER_IMAGE_WEB_IN_DEALS_PAGE_1 }"
                      (click)="openPDF(environmentVariables?.FLYER_PDF_IN_DEALS_PAGE_1)"
                      [src]="environmentVariables?.FLYER_IMAGE_WEB_IN_DEALS_PAGE_1"
                      class="web-view"
                      onError="this.src='./../../../../assets/images/section/600x160.png';"
                         alt="deals image"
                  />
                  </div>
                  <div class="devider"></div>
              </ng-container>
              <ng-container>
                <div class="single-img">
                  <img  loading="lazy" 
                  [ngClass]="{'hide-image-offer' : !environmentVariables?.FLYER_IMAGE_WEB_IN_DEALS_PAGE_2 }"
                  (click)="openPDF(environmentVariables?.FLYER_PDF_IN_DEALS_PAGE_2)"
                  [src]="environmentVariables?.FLYER_IMAGE_WEB_IN_DEALS_PAGE_2"
                  class="web-view"
                  onError="this.src='./../../../../assets/images/section/600x160.png';"
                     alt="deals image"

                  />
                </div>
                  <div class="devider"></div>
              </ng-container>
              <ng-container>
                <div class="single-img" >
                  <img  loading="lazy" 
                  [ngClass]="{'hide-image-offer' : !environmentVariables?.FLYER_IMAGE_WEB_IN_DEALS_PAGE_3 }"
                  (click)="openPDF(environmentVariables?.FLYER_PDF_IN_DEALS_PAGE_3)"
                  [src]="environmentVariables?.FLYER_IMAGE_WEB_IN_DEALS_PAGE_3"
                  class="web-view"
                  onError="this.src='./../../../../assets/images/section/600x160.png';"
                     alt="deals image"

                />
                </div>
                <div class="devider"></div>
              </ng-container>
            </div>

            <div class="multi-imgs-area d-flex" 
                *ngIf=" showOffers &&
                   (environmentVariables?.FLYER_IMAGE_IN_DEALS_PAGE_1
                || environmentVariables?.FLYER_IMAGE_IN_DEALS_PAGE_2 
                || environmentVariables?.FLYER_IMAGE_IN_DEALS_PAGE_3)">
              <ng-container >
                <div class="single-img" >
                  <img  loading="lazy" 
                     [ngClass]="{'hide-image-offer' : !environmentVariables?.FLYER_IMAGE_IN_DEALS_PAGE_1 }"
                     (click)="openPDF(environmentVariables?.FLYER_PDF_IN_DEALS_PAGE_1)"
                      [src]="environmentVariables?.FLYER_IMAGE_IN_DEALS_PAGE_1"
                      class="mob-view"
                      onError="this.src='./../../../../assets/images/section/600x160.png';"
                         alt="deals image"

                  />
                  </div>
                  <div class="devider"></div>
              </ng-container>
              <ng-container>
                <div class="single-img">
                  <img  loading="lazy" 
                      [ngClass]="{'hide-image-offer' : !environmentVariables?.FLYER_IMAGE_IN_DEALS_PAGE_2 }"
                      (click)="openPDF(environmentVariables?.FLYER_PDF_IN_DEALS_PAGE_2)"
                      [src]="environmentVariables?.FLYER_IMAGE_IN_DEALS_PAGE_2"
                      class="mob-view"
                      onError="this.src='./../../../../assets/images/section/600x160.png';"
                         alt="deals image"

                  />
    
                </div>
                  <div class="devider"></div>
              </ng-container>
              <ng-container>
                <div class="single-img" >
                <img  loading="lazy" 
                [ngClass]="{'hide-image-offer' : !environmentVariables?.FLYER_IMAGE_IN_DEALS_PAGE_3 }"
                   (click)="openPDF(environmentVariables?.FLYER_PDF_IN_DEALS_PAGE_3)"
                    [src]="environmentVariables?.FLYER_IMAGE_IN_DEALS_PAGE_3"
                    class="mob-view"
                    onError="this.src='./../../../../assets/images/section/600x160.png';"
                       alt="deals image"

                />
                </div>
                <div class="devider"></div>
              </ng-container>
            

            </div>
            <div class="col-gap" fxLayout="row wrap">
                <div
                    [ngClass]="sidenavOpen ? 'open-side-bar' : ''"
                    class="menu-filter-mobile"
                    fxFlex.lg="27"
                    fxFlex.md="35"
                    fxFlex.sm="100"
                    fxFlex.xl="25"
                    fxFlex.xs="100"
                >
                    <div class="filters-container">
                        <div class="text-right mat-cart-menu-mobile">
                            <button
                                (click)="openSideBar()"
                                class="btn-close-menu"
                                color="warn"
                                mat-icon-button
                            >
                                <mat-icon color="warn">close</mat-icon>
                            </button>
                        </div>

                        <div class="mat-card mb-4" style="height: 85px">
                            <mat-form-field class="w-100 height-45">
                                <input
                                    #searchq
                                    matInput
                                    placeholder="{{
                                        'product_list.searchProducts'
                                            | translate
                                    }}"
                                    type="text"
                                />
                            </mat-form-field>
                        </div>
                        <div
                            class="mat-card mb-4"
                            *ngIf="showResult || acceptPrice"
                        >
                            <h4
                                class="filter-header"
                                style="font-size: 18px !important"
                            >
                                {{ "product_list.price" | translate }}
                            </h4>

                            <div
                                class="rang-slider"
                                [dir]="lang === 'ar' ? 'rtl' : 'ltr'"
                            >
                                <input
                                    (keyup.enter)="updateRangWithData()"
                                    [(ngModel)]="minInputValue"
                                    [max]="maxValue"
                                    class="value-input"
                                    type="number"
                                    onkeypress="return (event.charCode >= 48 && event.charCode <= 57 ) || event.charCode == 46"
                                    onpaste="return (event.charCode >= 48 && event.charCode <= 57 ) || event.charCode == 46"
                                />
                                <input
                                    (keyup.enter)="updateRangWithData()"
                                    [(ngModel)]="maxInputValue"
                                    class="value-input"
                                    type="number"
                                    onkeypress="return (event.charCode >= 48 && event.charCode <= 57 ) || event.charCode == 46"
                                    onpaste="return (event.charCode >= 48 && event.charCode <= 57 ) || event.charCode == 46"
                                />
                            </div>
                            <mat-error *ngIf="maxInputValue < minInputValue">
                                {{ "product_list.priceValidation" | translate }}
                            </mat-error>

                            <div
                                [dir]="lang === 'ar' ? 'ltr' : 'rtl'"
                                class="d-inline-flex justify-space-between w-100"
                            >
                                <button
                                    (click)="updateProductsPriceRange()"
                                    [ngClass]="
                                        maxInputValue < minInputValue
                                            ? 'disabled'
                                            : ''
                                    "
                                    class="mt-2"
                                    color="brand-color"
                                    mat-raised-button
                                >
                                    {{ "product_list.apply" | translate }}
                                </button>
                                <div
                                    (click)="clearPriceRang()"
                                    class="mt-3 clear-price pointer"
                                >
                                    {{ "product_list.clear" | translate }}
                                </div>
                            </div>
                        </div>

                        <div class="mb-2">
                            <mat-accordion>
                                <mat-expansion-panel
                                    (closed)="panelOpenState = false"
                                    (opened)="panelOpenState = true"
                                    expanded
                                >
                                    <mat-expansion-panel-header>
                                        <mat-panel-title>
                                            <h4
                                                style="
                                                    font-size: 18px !important;
                                                "
                                                class="filter-header text-capitalize m-0"
                                            >
                                                {{
                                                    "product_list.categories"
                                                        | translate
                                                }}
                                            </h4>
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <mat-radio-group
                                        *ngIf="categories?.length"
                                        aria-label="Select an option"
                                        class="filter-brands flex-col"
                                    >
                                        <mat-radio-button
                                            (change)="
                                                searchProductCategory(category)
                                            "
                                            *ngFor="let category of categories"
                                            [checked]="category?.checked"
                                            [value]="category?.id"
                                            class="mb-1 x"
                                            color="primary"
                                        >
                                            {{
                                                lang === "en"
                                                    ? category?.name
                                                    : category?.name_ar
                                            }}
                                        </mat-radio-button>
                                    </mat-radio-group>
                                </mat-expansion-panel>
                            </mat-accordion>
                        </div>

                        <div class="mb-2" *ngIf="subCategories.length">
                            <mat-accordion>
                                <mat-expansion-panel
                                    (closed)="panelOpenState = false"
                                    (opened)="panelOpenState = true"
                                    expanded="{{ showSubCategory }}"
                                >
                                    <mat-expansion-panel-header>
                                        <mat-panel-title>
                                            <h4
                                                style="
                                                    font-size: 18px !important;
                                                "
                                                class="filter-header text-capitalize m-0"
                                            >
                                                {{
                                                    "product_list.subCategory"
                                                        | translate
                                                }}
                                            </h4>
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <div class="filter-brands">
                                        <div
                                            *ngFor="let group of subCategories"
                                        >
                                            <h6 class="name-group-list">
                                                {{
                                                    lang === "en"
                                                        ? group?.name
                                                        : group?.name_ar
                                                }}
                                            </h6>
                                            <div
                                                class="mx-3"
                                                *ngFor="
                                                    let subCategory of group?.sub_categories
                                                "
                                            >
                                                <mat-checkbox
                                                    (change)="
                                                        searchProductSubCategory(
                                                            $event,
                                                            subCategory
                                                        )
                                                    "
                                                    [checked]="
                                                        subCategory?.checked
                                                    "
                                                    [value]="subCategory?.id"
                                                    class="mb-1"
                                                    color="primary"
                                                >
                                                    {{
                                                        lang === "en"
                                                            ? subCategory?.name
                                                            : subCategory?.name_ar
                                                    }}
                                                </mat-checkbox>
                                            </div>
                                        </div>
                                    </div>
                                </mat-expansion-panel>
                            </mat-accordion>
                        </div>

                        <ng-container>
                            <ng-container *ngIf="!emptyProducts">
                                <div class="mb-2" *ngIf="brands?.length">
                                    <mat-accordion>
                                        <mat-expansion-panel
                                            expanded="{{ showBrands }}"
                                        >
                                            <mat-expansion-panel-header>
                                                <mat-panel-title>
                                                    <h6
                                                        style="
                                                            font-size: 18px !important;
                                                        "
                                                        class="filter-header text-capitalize m-0"
                                                    >
                                                        {{
                                                            lang === "en"
                                                                ? "Brands"
                                                                : "ماركات"
                                                        }}
                                                    </h6>
                                                </mat-panel-title>
                                            </mat-expansion-panel-header>
                                            <div
                                                *ngFor="let brand of brands"
                                                class="brands-filter"
                                            >
                                                <mat-checkbox
                                                    (change)="
                                                        searchProductByBrand(
                                                            $event,
                                                            brand
                                                        )
                                                    "
                                                    *ngIf="brand"
                                                    [checked]="brand?.checked"
                                                    [value]="brand?.id"
                                                    class="mb-1"
                                                    color="primary"
                                                >
                                                    {{
                                                        lang === "en"
                                                            ? brand?.name
                                                            : brand?.name_ar
                                                    }}
                                                </mat-checkbox>
                                            </div>
                                        </mat-expansion-panel>
                                    </mat-accordion>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="!emptyProducts">
                                <div
                                    *ngFor="
                                        let group of attributes;
                                        let i = index
                                    "
                                    class="mb-2"
                                >
                                    <ng-container *ngIf="group?.values?.length">
                                        <mat-accordion>
                                            <mat-expansion-panel
                                                [expanded]="
                                                    checkOptionFound(
                                                        group?.values
                                                    )
                                                "
                                            >
                                                <mat-expansion-panel-header>
                                                    <mat-panel-title>
                                                        <h6
                                                            style="
                                                                font-size: 18px !important;
                                                            "
                                                            class="filter-header text-capitalize m-0"
                                                        >
                                                            {{
                                                                lang === "en"
                                                                    ? group?.name
                                                                    : group?.name_ar
                                                            }}
                                                        </h6>
                                                    </mat-panel-title>
                                                </mat-expansion-panel-header>
                                                <ng-container
                                                    *ngIf="
                                                        group?.type == 2 &&
                                                        !environmentVariables?.SHOW_TEXT_COLOR
                                                    "
                                                >
                                                    <div
                                                        class="colors-container my-2 pb-3"
                                                    >
                                                        <ng-container
                                                            *ngFor="
                                                                let color of group?.values
                                                            "
                                                        >
                                                            <ng-container
                                                                *ngIf="
                                                                    !customColors.includes(
                                                                        color?.color_code
                                                                    )
                                                                "
                                                            >
                                                                <div
                                                                    (click)="
                                                                        searchProductByAttributes(
                                                                            {
                                                                                checked:
                                                                                    color?.checked
                                                                                        ? false
                                                                                        : true
                                                                            },
                                                                            color
                                                                        )
                                                                    "
                                                                    [matTooltip]="
                                                                        color?.name
                                                                    "
                                                                    [ngClass]="{
                                                                        active: color?.checked
                                                                    }"
                                                                    [style.background-color]="
                                                                        color?.color_code
                                                                    "
                                                                    class="color"
                                                                ></div>
                                                            </ng-container>
                                                            <ng-container
                                                                *ngIf="
                                                                    customColors.includes(
                                                                        color?.color_code
                                                                    )
                                                                "
                                                            >
                                                                <div
                                                                    (click)="
                                                                        searchProductByAttributes(
                                                                            {
                                                                                checked:
                                                                                    color?.checked
                                                                                        ? false
                                                                                        : true
                                                                            },
                                                                            color
                                                                        )
                                                                    "
                                                                    *ngIf="
                                                                        color?.color_code ===
                                                                        'transparent'
                                                                    "
                                                                    [matTooltip]="
                                                                        color?.name
                                                                    "
                                                                    [ngClass]="{
                                                                        active: color?.checked
                                                                    }"
                                                                    [style.background-image]="
                                                                        'url(./assets/images/transparent.png)'
                                                                    "
                                                                    class="color transparent"
                                                                ></div>
                                                                <div
                                                                    (click)="
                                                                        searchProductByAttributes(
                                                                            {
                                                                                checked:
                                                                                    color?.checked
                                                                                        ? false
                                                                                        : true
                                                                            },
                                                                            color
                                                                        )
                                                                    "
                                                                    *ngIf="
                                                                        color?.color_code ===
                                                                        'squad'
                                                                    "
                                                                    [matTooltip]="
                                                                        color?.name
                                                                    "
                                                                    [ngClass]="{
                                                                        active: color?.checked
                                                                    }"
                                                                    [style.background-image]="
                                                                        'url(./assets/images/squad-color.png)'
                                                                    "
                                                                    class="color transparent"
                                                                ></div>
                                                            </ng-container>
                                                        </ng-container>
                                                    </div>
                                                </ng-container>
                                                <ng-container
                                                    *ngIf="
                                                        group?.type == 2 &&
                                                        environmentVariables?.SHOW_TEXT_COLOR
                                                    "
                                                >
                                                    <div
                                                        class="colors-container my-2 pb-3 flex-column"
                                                    >
                                                        <ng-container
                                                            *ngFor="
                                                                let color of group?.values
                                                            "
                                                        >
                                                            <mat-checkbox
                                                                (change)="
                                                                    searchProductByAttributes(
                                                                        {
                                                                            checked:
                                                                                color?.checked
                                                                                    ? false
                                                                                    : true
                                                                        },
                                                                        color
                                                                    )
                                                                "
                                                                *ngIf="color"
                                                                [checked]="
                                                                    color?.checked
                                                                "
                                                                [value]="
                                                                    color?.id
                                                                "
                                                                class="mb-1"
                                                                color="primary"
                                                            >
                                                                {{
                                                                    lang == "en"
                                                                        ? color?.name
                                                                        : color?.name_ar
                                                                }}
                                                            </mat-checkbox>
                                                        </ng-container>
                                                    </div>
                                                </ng-container>
                                                <ng-container
                                                    *ngIf="group?.type != 2"
                                                >
                                                    <div
                                                        *ngFor="
                                                            let attrVal of group?.values
                                                        "
                                                    >
                                                        <mat-checkbox
                                                            (change)="
                                                                searchProductByAttributes(
                                                                    $event,
                                                                    attrVal
                                                                )
                                                            "
                                                            *ngIf="attrVal"
                                                            [checked]="
                                                                attrVal?.checked
                                                            "
                                                            [value]="
                                                                attrVal?.id
                                                            "
                                                            class="mb-1"
                                                            color="primary"
                                                        >
                                                            {{
                                                                lang === "en"
                                                                    ? attrVal?.name
                                                                    : attrVal?.name_ar
                                                            }}
                                                        </mat-checkbox>
                                                    </div>
                                                </ng-container>
                                            </mat-expansion-panel>
                                        </mat-accordion>
                                    </ng-container>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>

                <div
                    class="algolia-main-list"
                    fxFlex.lg="73"
                    fxFlex.md="65"
                    fxFlex.sm="100"
                    fxFlex.xl="75"
                    fxFlex.xs="100"
                >
                <h1 class="my-4 fs-24" style="font-weight: bolder">{{getTitleName(nameRouting)}}</h1>
                    <div class="top-filter">
                        <div class="top-filter__change-view d-lg-none w-100" fxLayout="row" fxLayoutAlign="space-between center">
                            <div>
                                <mat-card class="mat-cart-menu-mobile p-0">
                                    <button (click)="openSideBar()" class="btn-open-menu mt-2">
                                        <mat-icon
                                            [ngClass]="lang == 'ar' ? 'filter-ar' : ''"
                                            style="position: relative; top: 8px; left: -4px"
                                        >
                                            filter_list
                                        </mat-icon>
                                        <span class="filter-by">
                                            {{ "product_list.filterBy" | translate}}
                                        </span>
                                    </button>
                                </mat-card>
                            </div>

                            <div>
                                <button
                                    (click)="selectViewProduct('true')"
                                    class="hidden-in-mobile mat-icon-button"
                                    mat-icon-button=""
                                >
                                    <mat-icon
                                        [class.tabActive]="isGridView == 'true'"
                                        aria-hidden="true"
                                        class="mat-icon notranslate material-icons mat-icon-no-color"
                                        role="img"
                                    >
                                        view_list
                                    </mat-icon>
                                </button>
                                <button
                                    (click)="selectViewProduct('false')"
                                    class="hidden-in-mobile mat-icon-button"
                                    mat-icon-button=""
                                >
                                    <mat-icon
                                        [class.tabActive]="isGridView == 'false'"
                                        aria-hidden="true"
                                        class="mat-icon notranslate material-icons mat-icon-no-color"
                                        role="img"
                                    >
                                        view_module
                                    </mat-icon>
                                </button>
                            </div>
                        </div>

                        <div class="w-100" fxLayout.md="row" fxLayout.xs="column" 
                            fxLayoutAlign="space-between center">
                            <div
                                class="top-filter__item-length"
                            >
                                <mat-form-field appearance="fill">
                                    <mat-label>{{
                                        "product_list.sortBy" | translate
                                    }}</mat-label>
                                    <mat-select
                                        (selectionChange)="
                                            changePageItemsSort($event.value)
                                        "
                                        [(ngModel)]="filter.sort"
                                    >
                                        <mat-option
                                            *ngFor="let sort of sorts"
                                            [value]="sort?.value"
                                            >{{ sort.name | translate }}</mat-option
                                        >
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            
                            <div class="top-filter__item-length" fxLayout="row" fxLayoutAlign="center center">
                                <div class="d-lg-block d-none mb-3 mr-2">
                                    <button
                                        (click)="selectViewProduct('true')"
                                        class="hidden-in-mobile mat-icon-button"
                                        mat-icon-button=""
                                    >
                                        <mat-icon
                                            [class.tabActive]="isGridView == 'true'"
                                            aria-hidden="true"
                                            class="mat-icon notranslate material-icons mat-icon-no-color"
                                            role="img"
                                        >
                                            view_list
                                        </mat-icon>
                                    </button>
                                    <button
                                        (click)="selectViewProduct('false')"
                                        class="hidden-in-mobile mat-icon-button"
                                        mat-icon-button=""
                                    >
                                        <mat-icon
                                            [class.tabActive]="isGridView == 'false'"
                                            aria-hidden="true"
                                            class="mat-icon notranslate material-icons mat-icon-no-color"
                                            role="img"
                                        >
                                            view_module
                                        </mat-icon>
                                    </button>
                                </div>

                                <mat-form-field appearance="fill">
                                    <mat-label>{{
                                        "product_list.productsPerPage" | translate
                                    }}</mat-label>
                                    <mat-select
                                        (selectionChange)="
                                            changePageItems($event.value)
                                        "
                                        [(ngModel)]="filter.page_size"
                                    >
                                        <mat-option [value]="'24'">24</mat-option>
                                        <mat-option [value]="'48'">48</mat-option>
                                        <mat-option [value]="'100'">100</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>                            
                        </div>
                    </div>

                    <!-- categries -->
                    <div class="categries mb-4" *ngIf="filter?.promotions && environmentVariables?.SHOW_CATEGORIES_IN_DEALS_PAGE">
                        <mat-card>
                          <div class="container mt-4">
                            <div class="row categories-collection pb-1 mb-2" >
                              <div class="p-0 mb-5" style="cursor: pointer "  *ngFor="let category of categories">
                                <a style="margin: 0px auto !important"
                                    class="brand-item"
                                    [routerLink]="['/' + lang + '/products/deals/' + category?.slug]"
                                >
                                    <div class="imgContainer mx-2"
                                        [ngClass]="{'radius-50 shadow' : environmentVariables.CATEGORY_CARD == 'round' }">
                                        <img loading="lazy" 
                                            [ngClass]="{'radius-50 shadow' : environmentVariables.CATEGORY_CARD== 'round' }"
                                            [src]="category.image"
                                            [alt]="category?.name"
                                            class="swiper-lazy"
                                            onError="this.src='./assets/images/placeholder200.jpg';"
                                            default="./assets/images/placeholder200.jpg"
                                            style="
                                                position: relative;
                                                top: 0px;
                                                left: 0px;
                                                margin-left: 0px;
                                                margin-right: 0px;
                                                object-fit: contain;
                                            "
                                        />
                                        <h3 class="text-center product-text my-3" 
                                            style="color: var(--secoundry-color);">
                                            {{
                                                lang == "en"
                                                ? (category.name)
                                                : (category.name_ar)
                                            }}
                                        </h3>
                                    </div>
                                </a>
                              </div>
                            </div>
                          </div>
                        </mat-card>
                    </div>

                    <!-- brands -->
                    <div class="categries mb-4" *ngIf="brands?.length && environmentVariables?.ENABLE_BRANDS_ROW_IN_SEARCH">
                        <mat-card>
                          <div class="container overflow-x-auto mt-4">
                            <div class="row categories-collection pb-1 mb-2" >
                              <div class="p-0 mb-5" style="cursor: pointer" *ngFor="let brand of brands">
                                <a style="margin: 0px auto !important"
                                    class="brand-item"
                                    [routerLink]="['./']"
                                    [queryParams]="{
                                        brand_id: brand.id,
                                        page: 1
                                    }"
                                >
                                    <div class="imgBrandContainer mx-2"
                                        routerLinkActive="border border-brand rounded-lg"
                                        [ngClass]="{'radius-50 shadow' : environmentVariables.CATEGORY_CARD == 'round' }">
                                        <img loading="lazy" 
                                            [ngClass]="{'radius-50 shadow' : environmentVariables.CATEGORY_CARD== 'round' }"
                                            [src]="brand.image"
                                            [alt]="brand?.name"
                                            class="swiper-lazy"
                                            onError="this.src='./assets/images/placeholder200.jpg';"
                                            default="./assets/images/placeholder200.jpg"
                                            style="
                                                position: relative;
                                                top: 0px;
                                                left: 0px;
                                                margin-left: 0px;
                                                margin-right: 0px;
                                                object-fit: contain;
                                            "
                                        />
                                        <h3 class="text-center product-text my-3" 
                                            style="color: var(--secoundry-color);">
                                            {{
                                                lang == "en"
                                                ? (brand.name)
                                                : (brand.name_ar)
                                            }}
                                        </h3>
                                    </div>
                                </a>
                              </div>
                            </div>
                          </div>
                        </mat-card>
                    </div>
                    <ng-container *ngIf="loading && isGridView == 'false'">
                        <div class="skeleton-container">
                            <div
                                class="skeleton-list-container"
                                *ngFor="let item of fakeArray"
                            >
                                <div class="skeleton-container-inside">
                                    <div
                                        class="light-animate-shimmer image-shimmer"
                                    ></div>
                                    <div
                                        class="light-animate-shimmer description-shimmer"
                                    ></div>
                                    <div
                                        class="light-animate-shimmer price-shimmer"
                                    ></div>
                                    <div
                                        class="light-animate-shimmer price-shimmer"
                                    ></div>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="loading && isGridView == 'true'">
                        <div class="skeleton-container">
                            <div
                                class="skeleton-grid-container"
                                *ngFor="let item of fakeArray"
                            >
                                <div class="skeleton-container-inside">
                                    <div
                                        class="light-animate-shimmer image-shimmer"
                                    ></div>
                                    <div class="description-shimmer-container">
                                        <div
                                            class="light-animate-shimmer description-shimmer"
                                        ></div>
                                        <div
                                            class="light-animate-shimmer description-shimmer"
                                        ></div>
                                    </div>
                                    <div class="price-shimmer-container">
                                        <div
                                            class="light-animate-shimmer price-shimmer"
                                        ></div>
                                        <div
                                            class="light-animate-shimmer price-shimmer"
                                        ></div>
                                        <div
                                            class="light-animate-shimmer price-shimmer"
                                        ></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="products?.length && !loading">
                        <embryo-ProductGrid
                            (addToCart)="addToCart($event)"
                            (addToWishList)="addToWishList($event)"
                            [currentPage]="page"
                            [pageSize]="filter?.page_size"
                            [products]="products"
                            [totalPage]="totalPage"
                            [isGridView]="isGridView"
                            [gridThree]="true"
                        >
                        </embryo-ProductGrid>
                        <div fxLayout="row wrap">
                            <div fxFlex="100">
                                <mat-card class="p-0 text-center">
                                    <pagination-controls
                                        (pageChange)="onPageChanged($event)"
                                        class="product-pagination"
                                        nextLabel="{{
                                            'button.next' | translate
                                        }}"
                                        previousLabel="{{
                                            'button.previous' | translate
                                        }}"
                                    >
                                    </pagination-controls>
                                </mat-card>
                            </div>
                        </div>
                    </ng-container>

                    <span *ngIf="objectProducts?.products?.length == 0">
                      {{
                        "header.searchFail" | translate
                      }}
                  </span>
                </div>
            </div>
        </div>
    </div>
</ng-container>
